import { getTablePresets } from '../services';
export const fetchPresets = () => getTablePresets().then(response => formatResponse(response));
const formatResponse = (response) => ({
    presets: Object.entries(response?.presets ?? {}).map(([key, name]) => ({
        key,
        name,
    })),
    errors: response?.errors,
    success: response?.success,
});
